import { render, staticRenderFns } from "./IssueTrackerTable.vue?vue&type=template&id=93a1aa48&"
import script from "./IssueTrackerTable.vue?vue&type=script&lang=js&"
export * from "./IssueTrackerTable.vue?vue&type=script&lang=js&"
import style0 from "./IssueTrackerTable.vue?vue&type=style&index=0&id=93a1aa48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports